import { render } from "./AlertTypeComponent.vue?vue&type=template&id=c8dc9ac0"
import script from "./AlertTypeComponent.vue?vue&type=script&lang=js"
export * from "./AlertTypeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__